import { omit } from "lodash-es";

export type LongFormParams = {
  file?: {
    id?: string;
    name?: string;
  };
  db?: string;
  image_styles?: string;
  tone?: string;
};

export function mapLongformParams(params: LongFormParams): {
  db?: string;
  file_id?: string;
  file_name?: string;
  image_styles?: string;
  tone?: string;
} {
  return {
    ...Object.fromEntries(Object.entries(omit(params, "file")).filter(([, v]) => !!v)),
    ...(params?.file && { file_id: params.file.id, file_name: params.file.name }),
  };
}
